export default {
  welcome: 'Welcome Back to',
  signContinue: 'Sign in to continue to your account',
  resetSend: 'Password reset send',
  receiveEmail: 'You’ll receive an email if you are registered on our system',
  backToLogin: 'Back to Login',
}
